/**
 * Debug logging utility that only logs in development mode
 * Use this instead of console.log/debug/error throughout the codebase
 * to ensure no debug logs appear in production builds
 * 
 * Uses Vite's import.meta.env.DEV which is replaced at build time
 * to ensure proper dead code elimination in production builds
 */
const isDev = (() => {
    // Check if we're in Node.js environment (ts-node, etc.)
    if (typeof process !== 'undefined' && process.env) {
        return process.env.NODE_ENV !== 'production';
    }
    // Browser/Vite environment
    // In Vite builds, import.meta.env.DEV is replaced at build time with a boolean literal
    // This allows proper dead code elimination in production builds
    try {
        // Vite replaces import.meta.env.DEV at build time, so this is safe
        // @ts-ignore - TypeScript may not recognize import.meta in all contexts
        return import.meta.env.DEV === true;
    } catch {
        // import.meta not available (shouldn't happen in Vite, but handle gracefully)
        // Fallback: assume dev mode if we can't determine
        return true;
    }
})();

export const debugLog = (...args: any[]) => {
    if (isDev) {
        console.debug(...args);
    }
};

export const debugError = (...args: any[]) => {
    // Errors should appear regardless of build environment
    //if (import.meta.env.DEV) {
    console.error(...args);
    //}
};

export const debugWarn = (...args: any[]) => {
    // Warnings should appear regardless of build environment
    //if (import.meta.env.DEV) {
    console.warn(...args);
    //}
};

export const debugInfo = (...args: any[]) => {
    if (isDev) {
        console.info(...args);
    }
};

